import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.index-of";
import { theme } from 'styled-tools';
import styled from './styled.js';
import { b as _objectSpread, a as _extends, c as _objectWithoutPropertiesLoose } from './chunk-79dadc73.js';
import { createElement } from 'react';
import { b as omit, a as as } from './as-39ca1b5e.js';
import { object, func, bool } from 'prop-types';
import Box from './Box.js';
import { a as callAll } from './chunk-11bd1c20.js';
import { Container } from 'constate';
var initialState = {
  loop: false,
  ids: [],
  current: -1,
  ordered: {}
};
var selectors = {
  getCurrentId: function getCurrentId() {
    return function (state) {
      return state.ids[state.current];
    };
  },
  hasPrevious: function hasPrevious() {
    return function (state) {
      return state.ids.length > 1 && !!state.ids[state.current - 1];
    };
  },
  hasNext: function hasNext() {
    return function (state) {
      return state.ids.length > 1 && !!state.ids[state.current + 1];
    };
  },
  indexOf: function indexOf(idOrIndex) {
    return function (state) {
      return typeof idOrIndex === "number" ? idOrIndex : state.ids.indexOf(idOrIndex);
    };
  },
  isCurrent: function isCurrent(idOrIndex) {
    return function (state) {
      return state.current >= 0 && state.current === selectors.indexOf(idOrIndex)(state);
    };
  }
};
var actions = {
  show: function show(idOrIndex) {
    return function (state) {
      return {
        current: selectors.indexOf(idOrIndex)(state)
      };
    };
  },
  hide: function hide() {
    return function () {
      return {
        current: -1
      };
    };
  },
  toggle: function toggle(idOrIndex) {
    return function (state) {
      return selectors.isCurrent(idOrIndex)(state) ? actions.hide()(state) : actions.show(idOrIndex)(state);
    };
  },
  previous: function previous() {
    return function (state) {
      if (selectors.hasPrevious()(state)) {
        return {
          current: state.current - 1
        };
      }

      if (state.loop) {
        return {
          current: state.ids.length - 1
        };
      }

      return {};
    };
  },
  next: function next() {
    return function (state) {
      if (selectors.hasNext()(state)) {
        return {
          current: state.current + 1
        };
      }

      if (state.loop) {
        return {
          current: 0
        };
      }

      return {};
    };
  },
  reorder: function reorder(id, order) {
    if (order === void 0) {
      order = 0;
    }

    return function (state) {
      var _objectSpread2;

      var ordered = _objectSpread({}, state.ordered, (_objectSpread2 = {}, _objectSpread2[id] = order, _objectSpread2));

      var ids = state.ids.slice().sort(function (a, b) {
        return (ordered[a] || 0) - (ordered[b] || 0);
      });
      return _objectSpread({
        ordered: ordered,
        ids: ids
      }, selectors.isCurrent(id)(state) ? actions.show(id)(_objectSpread({}, state, {
        ids: ids
      })) : {});
    };
  },
  register: function register(id, order) {
    if (order === void 0) {
      order = 0;
    }

    return function (state) {
      var ids = state.ids.indexOf(id) >= 0 ? state.ids : [].concat(state.ids, [id]);
      return actions.reorder(id, order)(_objectSpread({}, state, {
        ids: ids
      }));
    };
  },
  unregister: function unregister(id) {
    return function (state) {
      var index = selectors.indexOf(id)(state);

      if (index === -1) {
        return {};
      }

      var ordered = omit(state.ordered, state.ids[index]);
      var ids = [].concat(state.ids.slice(0, index), state.ids.slice(index + 1));

      if (selectors.isCurrent(id)(state) && !selectors.hasNext()(state)) {
        if (selectors.hasPrevious()(state)) {
          return _objectSpread({}, actions.previous()(state), {
            ids: ids,
            ordered: ordered
          });
        }

        return _objectSpread({}, actions.hide()(state), {
          ids: ids,
          ordered: ordered
        });
      }

      if (state.current >= ids.length) {
        return {
          current: ids.length - 1,
          ids: ids,
          ordered: ordered
        };
      }

      return {
        ids: ids,
        ordered: ordered
      };
    };
  },
  update: function update(id, nextId, orderArg) {
    return function (state) {
      var order = typeof orderArg !== "undefined" ? orderArg : state.ordered[id];
      var idChanged = id !== nextId;
      var orderChanged = order !== state.ordered[id];
      if (!idChanged && !orderChanged) return {};
      var overridingId = idChanged && state.ids.indexOf(nextId) >= 0;

      if (overridingId) {
        var nextOrderChanged = order !== state.ordered[nextId];
        var nextState = nextOrderChanged ? actions.reorder(nextId, order)(state) : {};
        return actions.unregister(id)(_objectSpread({}, state, nextState));
      }

      var index = selectors.indexOf(id)(state);
      var ids = [].concat(state.ids.slice(0, index), [nextId], state.ids.slice(index + 1));
      return actions.reorder(nextId, order)(_objectSpread({}, state, {
        ids: ids
      }));
    };
  }
}; // istanbul ignore next

var StepContainer = function StepContainer(props) {
  return createElement(Container, _extends({}, props, {
    initialState: _objectSpread({}, initialState, props.initialState),
    selectors: selectors,
    actions: actions
  }));
}; // @ts-ignore


StepContainer.propTypes = {
  initialState: object
};
var StepContainer$1 = Object.assign(StepContainer, {
  initialState: initialState,
  actions: actions,
  selectors: selectors
});

var StepNextComponent = function StepNextComponent(_ref) {
  var onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["onClick"]);

  return createElement(Box, _extends({
    onClick: callAll(props.next, onClick),
    disabled: !props.loop && props.hasNext && !props.hasNext()
  }, props));
};

var StepNext = styled(StepNextComponent).withConfig({
  displayName: "StepNext",
  componentId: "sc-1tlsqf3-0"
})(["", ";"], theme("StepNext")); // @ts-ignore

StepNext.propTypes = {
  next: func.isRequired,
  hasNext: func,
  loop: bool,
  onClick: func
};
var StepNext$1 = as("button")(StepNext);

var StepPreviousComponent = function StepPreviousComponent(_ref) {
  var onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["onClick"]);

  return createElement(Box, _extends({
    onClick: callAll(props.previous, onClick),
    disabled: !props.loop && props.hasPrevious && !props.hasPrevious()
  }, props));
};

var StepPrevious = styled(StepPreviousComponent).withConfig({
  displayName: "StepPrevious",
  componentId: "sc-1d6cvgj-0"
})(["", ";"], theme("StepPrevious")); // @ts-ignore

StepPrevious.propTypes = {
  previous: func.isRequired,
  hasPrevious: func,
  loop: bool,
  onClick: func
};
var StepPrevious$1 = as("button")(StepPrevious);
export { StepContainer$1 as a, StepNext$1 as b, StepPrevious$1 as c };